import { JsonObject, JsonProperty } from 'json2typescript';
import Thumbnail from '@/models/exam/Thumbnail';
import BenefitsDetail from './BenefitsDetail';

@JsonObject('benefit')
export default class Benefit {
  constructor() {
    this.examRankBenefitsId = undefined;
    this.displayType = undefined;
    this.benefitsType = undefined;
    this.thumbnail = new Thumbnail();
    this.order = undefined;
    this.name = undefined;
    this.explanation = undefined;
    this.notes = undefined;
    this.details = new Array<BenefitsDetail>();
  }

  @JsonProperty('exam_rank_benefits_id')
  public examRankBenefitsId?: number;

  @JsonProperty('display_type')
  public displayType?: string;

  @JsonProperty('benefits_type')
  public benefitsType?: string;

  @JsonProperty('thumbnail', Thumbnail, true)
  public thumbnail: Thumbnail;

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('explanation')
  public explanation?: string;

  @JsonProperty('notes')
  public notes?: string;

  @JsonProperty('details', [BenefitsDetail], true)
  public details: BenefitsDetail[] = [];
}
